<svg [attr.height]="size" [attr.width]="size" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 8.25C10.11 8.25 9.75 9.04 9.75 10.5V11.12H14.25V10.5C14.25 9.04 13.89 8.25 12 8.25Z"
        [attr.fill]="color" [attr.stroke]="color"/>
  <path
    d="M12 15.6C12.6075 15.6 13.1 15.1075 13.1 14.5C13.1 13.8925 12.6075 13.4 12 13.4C11.3925 13.4 10.9 13.8925 10.9 14.5C10.9 15.1075 11.3925 15.6 12 15.6Z"
    [attr.fill]="color" [attr.stroke]="color"/>
  <path
    d="M12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM17.38 15C17.38 17.2 16.7 17.88 14.5 17.88H9.5C7.3 17.88 6.62 17.2 6.62 15V14C6.62 12.29 7.03 11.5 8.25 11.23V10.5C8.25 9.57 8.25 6.75 12 6.75C15.75 6.75 15.75 9.57 15.75 10.5V11.23C16.97 11.5 17.38 12.29 17.38 14V15Z"
    [attr.fill]="color" [attr.stroke]="color"/>
</svg>
